export default {
  props: ["headers", "items", "noDataText", "global", "channels"],
  data: () => ({
    page: 1,
    itemsPerPage: 10,
    filter: {
      s: ""
    }
  }),
  methods: {
    getChannelTitles(itemChannels) {
      if (!Array.isArray(itemChannels) || !itemChannels.length) {
        return "-";
      }
      return itemChannels
        .map(
          channel =>
            this.channels?.find(channelItem => channelItem.value === channel)
              ?.title ?? channel
        )
        .join(", ");
    },
    async nextPage() {
      const pages = Math.ceil(this.items.length / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    async previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    }
  }
};
